export default "__VITE_ASSET__DHBkcn4s__"